import Header1 from 'elements/Header1';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const Headline = Header1.extend`
  padding: 0 ${ds.get('metrics.s')};
  font-size: ${ds.fontSize('l')};
  line-height: 1.15;
  margin-top: ${ds.get('metrics.l')};
  
  ${media.tablet`
    padding: 0 ${ds.get('metrics.s')};
    font-size: ${ds.fontSize('xl')};
    margin: ${ds.get('metrics.xl')} 0 ${ds.get('metrics.s')} 0;
  `}
  
  ${media.desktop`
    font-size: ${ds.fontSize('xxl')};
    margin: 160px 0 0 0;
  `}
`;

export default Headline;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HeroImage/TextBlock/Headline.jsx